import NotebookService from "utilities/services/notebooks/notebook-service";
import useNotebooksAtom from "./use-notebooks-atom";
import { useGlobalState } from "utilities/contexts/use-global-state-context";
import { useMemo } from "react";

const useUserNotebookPermissions = () => {
    const { get: getUserPermissionsApi } =
        NotebookService.useUserPermissionsQuery();

    const { globalState } = useGlobalState();
    const userId = globalState.currentIdentity?.user?.id ?? 0;

    const { resultObject: notebooks } = useNotebooksAtom();

    const sharedNotebookIds: number[] = useMemo(() => {
        if (userId === 0) return [];

        const ids = notebooks
            .filter((n) => n.id != null && n.ownerId !== userId)
            .map((n) => n.id)
            .filter((id): id is number => id != null);
        const distinctIds = Array.from(new Set(ids));
        return distinctIds;
    }, [userId, notebooks]);

    const { data: userNotebookPermissionsResult } = getUserPermissionsApi(
        {},
        { notebookIds: sharedNotebookIds },
        {
            enabled: sharedNotebookIds.length > 0,
            keepPreviousData: true,
            staleTime: 5 * 60 * 1000, // 5 minutes in milliseconds
        }
    );

    return {
        userNotebookPermissions: userNotebookPermissionsResult?.resultObject,
    };
};

export default useUserNotebookPermissions;
